<template lang="pug">
v-app
  v-container(grid-list-xl, fluid).resumo-container

    //- Header
    v-layout(row, wrap, align-center).mb-2
      v-flex(xs12, md6)
        .resumo-title Resumo
        .resumo-subtitle Visão geral do desempenho do seu negócio
      v-flex(xs12, md6)
        .periodo-selector
          button.periodo-btn(
            v-for="p in periodos",
            :key="p.dias",
            :class="{ 'periodo-btn--active': periodo === p.dias }",
            @click="setPeriodo(p.dias)"
          ) {{ p.label }}

    //- KPI Cards Row
    v-layout(row, wrap).mt-2
      v-flex(xs12, sm6, md3)
        .kpi-card
          .kpi-card__icon-wrap.kpi-card__icon-wrap--green
            v-icon.kpi-card__icon monetization_on
          .kpi-card__label Vendas
          .kpi-card__value(v-if="!loading") {{ kpis.atual.totalBruto | currency }}
          .kpi-card__value--skeleton(v-else)
          .kpi-card__sub(v-if="!loading") {{ kpis.atual.quantidadePedidos | number }} pedidos
          .kpi-card__badge-row(v-if="!loading && kpis.anterior.totalBruto > 0")
            span.kpi-badge(:class="variacaoClass(kpis.atual.totalBruto, kpis.anterior.totalBruto)")
              v-icon(small) {{ variacaoIcon(kpis.atual.totalBruto, kpis.anterior.totalBruto) }}
              | {{ variacaoPct(kpis.atual.totalBruto, kpis.anterior.totalBruto) }}% vs período anterior
          .kpi-card__hint(@click="$router.push('/delivery/relatorio/pedidos')") Ver relatório de pedidos →
          .kpi-card__cta-cupom(v-if="atalhoVendas && !loading && $root.podeAcessarPerfil(['administrador'])", @click.stop="handleCtaCupom(atalhoVendas, 'vendas')")
            v-icon(small, style="color:#C9971E;margin-right:4px") star
            span {{ atalhoVendas.texto }} →

      v-flex(xs12, sm6, md3)
        .kpi-card
          .kpi-card__icon-wrap.kpi-card__icon-wrap--blue
            v-icon.kpi-card__icon person_add
          .kpi-card__label Novos Clientes
          .kpi-card__value(v-if="!loading") {{ kpis.atual.novosClientes | number }}
          .kpi-card__value--skeleton(v-else)
          .kpi-card__sub(v-if="!loading") pedidos de 1ª compra
          .kpi-card__badge-row(v-if="!loading && kpis.anterior.novosClientes > 0")
            span.kpi-badge(:class="variacaoClass(kpis.atual.novosClientes, kpis.anterior.novosClientes)")
              v-icon(small) {{ variacaoIcon(kpis.atual.novosClientes, kpis.anterior.novosClientes) }}
              | {{ variacaoPct(kpis.atual.novosClientes, kpis.anterior.novosClientes) }}% vs período anterior
          .kpi-card__cta-cupom(v-if="atalhoNovosClientes && !loading && $root.podeAcessarPerfil(['administrador'])", @click="handleCtaCupom(atalhoNovosClientes, 'novos_clientes')")
            v-icon(small, style="color:#C9971E;margin-right:4px") star
            span {{ atalhoNovosClientes.texto }} →

      v-flex(xs12, sm6, md3)
        .kpi-card
          .kpi-card__icon-wrap.kpi-card__icon-wrap--purple
            v-icon.kpi-card__icon people
          .kpi-card__label Clientes Recorrentes
          .kpi-card__value(v-if="!loading") {{ kpis.atual.recorrentes | number }}
          .kpi-card__value--skeleton(v-else)
          .kpi-card__sub(v-if="!loading") pedidos de clientes já atendidos
          .kpi-card__badge-row(v-if="!loading && kpis.anterior.recorrentes > 0")
            span.kpi-badge(:class="variacaoClass(kpis.atual.recorrentes, kpis.anterior.recorrentes)")
              v-icon(small) {{ variacaoIcon(kpis.atual.recorrentes, kpis.anterior.recorrentes) }}
              | {{ variacaoPct(kpis.atual.recorrentes, kpis.anterior.recorrentes) }}% vs período anterior

      v-flex(xs12, sm6, md3)
        .kpi-card
          .kpi-card__icon-wrap.kpi-card__icon-wrap--red
            v-icon.kpi-card__icon cancel
          .kpi-card__label Taxa de Cancelamento
          .kpi-card__value(v-if="!loading") {{ taxaCancelamento(kpis.atual) }}%
          .kpi-card__value--skeleton(v-else)
          .kpi-card__sub(v-if="!loading") {{ kpis.atual.cancelados | number }} de {{ (kpis.atual.quantidadePedidos + kpis.atual.cancelados) | number }} pedidos
          .kpi-card__badge-row(v-if="!loading && kpis.anterior.cancelados + kpis.anterior.quantidadePedidos > 0")
            span.kpi-badge(:class="taxaVarClass()")
              v-icon(small) {{ taxaVarIcon() }}
              | {{ taxaVarPct() }}% vs período anterior

    //- Gráfico de Tendência
    v-layout(row, wrap).mt-3(v-if="!loading && chartData.length")
      v-flex(xs12)
        .kpi-card.pa-4
          .kpi-section-title Tendência de Vendas (por dia)
          .chart-legend
            span.legend-dot.legend-dot--atual
            span.legend-text Período atual ({{ legendRanges.atual }}) &nbsp;
            span.legend-dot.legend-dot--anterior
            span.legend-text Período anterior ({{ legendRanges.anterior }})
          .chart-wrapper
            e-chart(:path-option="chartOptions", height="260px", width="100%")

    //- Top Clientes + Top Itens
    v-layout(row, wrap).mt-3(v-if="!loading")
      v-flex(xs12, md6)
        .kpi-card.pa-4
          .kpi-section-title Top Clientes
          .kpi-section-sub por valor total no período
          template(v-if="topClientes.length")
            .top-item(v-for="(c, i) in topClientes", :key="c.usuario_id")
              .top-item__rank(:class="rankClass(i)") {{ i + 1 }}
              .top-item__info
                .top-item__name {{ c.usuario_nome || 'Cliente sem nome' }}
                .top-item__sub {{ c.quantidade | number }} pedidos
              .top-item__value {{ c.total | currency }}
          .empty-state(v-else)
            v-icon.empty-state__icon sentiment_dissatisfied
            span Sem dados no período

      v-flex(xs12, md6)
        .kpi-card.pa-4
          .kpi-section-title Top Itens Vendidos
          .kpi-section-sub por quantidade no período
          template(v-if="topItens.length")
            .top-item(v-for="(item, i) in topItens", :key="item.nome")
              .top-item__rank(:class="rankClass(i)") {{ i + 1 }}
              .top-item__info
                .top-item__name {{ item.nome }}
              .top-item__value {{ item.quantidade | number }} un.
          .empty-state(v-else)
            v-icon.empty-state__icon info_outline
            span Dados de itens não disponíveis

</template>

<script>
import _ from 'lodash';
import EChart from '@/components/EChart';

export default {
  components: { EChart },
  data() {
    return {
      periodo: 7,
      periodos: [
        { dias: 7, label: 'Últimos 7 dias' },
        { dias: 14, label: 'Últimos 14 dias' },
        { dias: 28, label: 'Últimos 28 dias' },
      ],
      loading: false,
      pedidosAtuais: [],
      pedidosAnteriores: [],
      pedidos28d: [],
      cuponsDestaque: [],
    };
  },
  computed: {
    estabelecimentoSelecionado() {
      return this.$root.estabelecimentoSelecionado;
    },
    kpis() {
      return {
        atual: this.calcKpis(this.pedidosAtuais),
        anterior: this.calcKpis(this.pedidosAnteriores),
      };
    },
    topClientes() {
      const validos = _.filter(this.pedidosAtuais, o => o.status === 1 || o.status === 2);
      const grouped = _.groupBy(validos, 'usuario_id');
      const list = _.map(grouped, (pedidos, id) => ({
        usuario_id: id,
        usuario_nome: pedidos[0].usuario_nome,
        quantidade: pedidos.length,
        total: _.sumBy(pedidos, o => this.calcBruto(o)),
      }));
      return _.take(_.orderBy(list, 'total', 'desc'), 5);
    },
    topItens() {
      const validos = _.filter(this.pedidosAtuais, o => (o.status === 1 || o.status === 2) && o.itens && o.itens.length);
      if (!validos.length) return [];
      const allItens = _.flatMap(validos, o => o.itens);
      const grouped = _.groupBy(allItens, ip => ip.item && ip.item.nome);
      const list = _.map(grouped, (itens, nome) => ({
        nome,
        quantidade: _.sumBy(itens, 'quantidade'),
      }));
      return _.take(_.orderBy(list, 'quantidade', 'desc'), 5);
    },
    chartData() {
      const N = this.periodo;
      const days = [];
      for (let i = N; i >= 1; i--) {
        days.push(this.$dayjs().subtract(i, 'day').format('DD/MM'));
      }
      return days;
    },
    chartDataAnterior() {
      const N = this.periodo;
      const days = [];
      for (let i = N; i >= 1; i--) {
        days.push(this.$dayjs().subtract(N + i, 'day').format('DD/MM'));
      }
      return days;
    },
    legendRanges() {
      const N = this.periodo;
      const hoje = this.$dayjs();
      return {
        atual: `${hoje.subtract(N, 'day').format('DD/MM')} - ${hoje.subtract(1, 'day').format('DD/MM')}`,
        anterior: `${hoje.subtract(2 * N, 'day').format('DD/MM')} - ${hoje.subtract(N + 1, 'day').format('DD/MM')}`,
      };
    },
    chartOptions() {
      const N = this.periodo;
      const days = this.chartData;
      const previousDays = this.chartDataAnterior;

      const serieAtual = days.map((d, i) => {
        const day = this.$dayjs().subtract(N - i, 'day').format('YYYY-MM-DD');
        const pedidosDia = _.filter(this.pedidosAtuais, o =>
          (o.status === 1 || o.status === 2) &&
          this.$dayjs(o.data).format('YYYY-MM-DD') === day
        );
        return parseFloat(_.sumBy(pedidosDia, o => this.calcBruto(o)).toFixed(2));
      });

      const serieAnterior = days.map((d, i) => {
        const day = this.$dayjs().subtract(2 * N - i, 'day').format('YYYY-MM-DD');
        const pedidosDia = _.filter(this.pedidosAnteriores, o =>
          (o.status === 1 || o.status === 2) &&
          this.$dayjs(o.data).format('YYYY-MM-DD') === day
        );
        return parseFloat(_.sumBy(pedidosDia, o => this.calcBruto(o)).toFixed(2));
      });

      return [
        ['tooltip.trigger', 'axis'],
        ['tooltip.formatter', (params) => {
          const idx = params[0].dataIndex;
          const dateAtual = days[idx];
          const dateAnterior = previousDays[idx];
          const header = `<b>${dateAtual}</b> vs <b>${dateAnterior}</b>`;
          const lines = params.map(p =>
            `<span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:${p.color};margin-right:6px;"></span>${p.seriesName}: R$ ${p.value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`
          );
          return header + '<br/>' + lines.join('<br/>');
        }],
        ['legend.show', false],
        ['grid.top', '10%'],
        ['grid.left', '60'],
        ['grid.right', '20'],
        ['grid.bottom', '30'],
        ['xAxis', { type: 'category', data: days, axisLine: { lineStyle: { color: '#ddd' } }, axisLabel: { color: '#888' } }],
        ['yAxis', { type: 'value', axisLabel: { color: '#888', formatter: (v) => 'R$ ' + v.toLocaleString('pt-BR') }, splitLine: { lineStyle: { color: '#f0f0f0' } } }],
        ['series', [
          {
            name: 'Período atual',
            type: 'bar',
            data: serieAtual,
            itemStyle: { color: '#1d9a5a', borderRadius: [4, 4, 0, 0] },
            barMaxWidth: 24,
          },
          {
            name: 'Período anterior',
            type: 'bar',
            data: serieAnterior,
            itemStyle: { color: '#ddd', borderRadius: [4, 4, 0, 0] },
            barMaxWidth: 24,
          },
        ]],
      ];
    },
    isCardapioDigital() {
      return !!this.estabelecimentoSelecionado?.cardapio_digital
    },
    contratoSuspenso() {
      return this.estabelecimentoSelecionado?.status_delivery == 4
    },
    habilitadoDestaque() {
      if (this.isCardapioDigital) return true;
      const pedidos = this.pedidos28d;
      const totalPedidos = pedidos.length;
      if (totalPedidos === 0) return true;
      const cancelados = pedidos.filter(o => o.status === 3).length;
      const taxa = (cancelados / totalPedidos) * 100;
      if (totalPedidos > 10 && taxa > 50) return false;
      if (totalPedidos <= 10 && taxa > 75) return false;
      return true;
    },
    temDestaqueFidelizar() {
      const hoje = this.$dayjs();
      return this.cuponsDestaque.some(c =>
        c.ativo === 1 &&
        !c.primeiro_pedido_estabelecimento &&
        !c.taxa_entrega &&
        (!c.data_fim || !this.$dayjs(c.data_fim).isBefore(hoje))
      );
    },
    temDestaqueEntregaGratis() {
      const hoje = this.$dayjs();
      return this.cuponsDestaque.some(c =>
        c.ativo === 1 &&
        c.taxa_entrega === 1 &&
        (!c.data_fim || !this.$dayjs(c.data_fim).isBefore(hoje))
      );
    },
    temDestaquePrimeiroPedido() {
      const hoje = this.$dayjs();
      return this.cuponsDestaque.some(c =>
        c.ativo === 1 &&
        c.primeiro_pedido_estabelecimento === 1 &&
        (!c.data_fim || !this.$dayjs(c.data_fim).isBefore(hoje))
      );
    },
    atalhoVendas() {
      if (!this.estabelecimentoSelecionado?.id || this.contratoSuspenso || !this.habilitadoDestaque) return null;
      if (!this.temDestaqueFidelizar) {
        return { texto: this.isCardapioDigital ? 'Ative um cupom e aumente suas vendas' : 'Ative um cupom de destaque e aumente suas vendas', tipo: 'fidelizar' };
      }
      if (!this.temDestaqueEntregaGratis) {
        return { texto: 'Ofereça entrega grátis e aumente seus pedidos', tipo: 'entrega' };
      }
      return null;
    },
    atalhoNovosClientes() {
      if (!this.estabelecimentoSelecionado?.id || this.contratoSuspenso || !this.habilitadoDestaque) return null;
      if (!this.temDestaquePrimeiroPedido) {
        return { texto: 'Crie um cupom de 1º pedido e atraia novos clientes' };
      }
      return null;
    },
  },
  watch: {
    atalhoVendas(val) {
      if (val) this.trackBannerShown('vendas', val);
    },
    atalhoNovosClientes(val) {
      if (val) this.trackBannerShown('novos_clientes', val);
    },
  },
  created() {
    window.getApp.$on('CHANGE_ESTABELECIMENTO', this.onChangeEstabelecimento);
  },
  beforeDestroy() {
    window.getApp.$off('CHANGE_ESTABELECIMENTO', this.onChangeEstabelecimento);
  },
  mounted() {
    this.onChangeEstabelecimento();
  },
  methods: {
    onChangeEstabelecimento() {
      this.fetchData();
      this.fetchDados28d();
      this.fetchCuponsDestaque();
    },
    setPeriodo(dias) {
      this.periodo = dias;
      this.fetchData();
    },
    async fetchData() {
      this.loading = true;
      const N = this.periodo;
      const hoje = this.$dayjs();

      const dataInicioAtual = hoje.subtract(N, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss');
      const dataFimAtual = hoje.subtract(1, 'day').endOf('day').format('YYYY-MM-DD HH:mm:ss');

      const dataInicioAnterior = hoje.subtract(2 * N, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss');
      const dataFimAnterior = hoje.subtract(N + 1, 'day').endOf('day').format('YYYY-MM-DD HH:mm:ss');

      const params = (inicio, fim) => ({
        estabelecimento_id: this.estabelecimentoSelecionado ? this.estabelecimentoSelecionado.id : null,
        data_inicio: inicio,
        data_fim: fim,
        columns: 'estabelecimento,localidade,estado,usuario,forma_pagamento',
        fields: 'itens',
        orderDesc: 'data',
        statusList: '1,2,3',
      });

      try {
        const [resAtual, resAnterior] = await Promise.all([
          this.$axios.get('/pedido', { params: params(dataInicioAtual, dataFimAtual) }),
          this.$axios.get('/pedido', { params: params(dataInicioAnterior, dataFimAnterior) }),
        ]);

        this.pedidosAtuais = this.enrich(resAtual.data);
        this.pedidosAnteriores = this.enrich(resAnterior.data);
      } catch (error) {
        const err = error.response && error.response.data ? error.response.data.error : 'Erro ao carregar dados. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
      }

      this.loading = false;
    },
    enrich(pedidos) {
      return pedidos.map(p => {
        p.incentivo = p.estabelecimento_cupom == 1 ? p.reembolso_promocao : p.reembolso_promocao + p.desconto;
        p.total_liquido = p.total;
        p.total_bruto = p.total + p.incentivo;
        return p;
      });
    },
    calcBruto(o) {
      const comissaoReembolso = this.$dayjs(o.data).isAfter(this.$dayjs('2024-03-31 23:59:59'));
      const reembolso = comissaoReembolso ? o.reembolso_promocao : 0;
      return o.estabelecimento_cupom == 1 ? o.total + reembolso : (o.total + o.desconto + reembolso);
    },
    calcKpis(pedidos) {
      const validos = _.filter(pedidos, o => o.status === 1 || o.status === 2);
      const cancelados = _.filter(pedidos, o => o.status === 3);
      const novos = _.filter(validos, o => o.primeiro || o.primeiro_estabelecimento);
      return {
        totalBruto: _.sumBy(validos, o => this.calcBruto(o)),
        quantidadePedidos: validos.length,
        novosClientes: novos.length,
        recorrentes: validos.length - novos.length,
        cancelados: cancelados.length,
      };
    },
    taxaCancelamento(kpi) {
      const total = kpi.quantidadePedidos + kpi.cancelados;
      if (!total) return '0,0';
      return ((kpi.cancelados / total) * 100).toFixed(1).replace('.', ',');
    },
    variacaoPct(atual, anterior) {
      if (!anterior) return '—';
      return Math.abs(((atual - anterior) / anterior) * 100).toFixed(1).replace('.', ',');
    },
    variacaoClass(atual, anterior) {
      if (!anterior) return '';
      return atual >= anterior ? 'kpi-badge--up' : 'kpi-badge--down';
    },
    variacaoIcon(atual, anterior) {
      if (!anterior) return '';
      return atual >= anterior ? 'arrow_upward' : 'arrow_downward';
    },
    taxaVarPct() {
      const tAtual = parseFloat(this.taxaCancelamento(this.kpis.atual).replace(',', '.'));
      const tAnterior = parseFloat(this.taxaCancelamento(this.kpis.anterior).replace(',', '.'));
      if (!tAnterior) return '—';
      return Math.abs(tAtual - tAnterior).toFixed(1).replace('.', ',');
    },
    taxaVarClass() {
      const tAtual = parseFloat(this.taxaCancelamento(this.kpis.atual).replace(',', '.'));
      const tAnterior = parseFloat(this.taxaCancelamento(this.kpis.anterior).replace(',', '.'));
      return tAtual <= tAnterior ? 'kpi-badge--up' : 'kpi-badge--down';
    },
    taxaVarIcon() {
      const tAtual = parseFloat(this.taxaCancelamento(this.kpis.atual).replace(',', '.'));
      const tAnterior = parseFloat(this.taxaCancelamento(this.kpis.anterior).replace(',', '.'));
      return tAtual <= tAnterior ? 'arrow_downward' : 'arrow_upward';
    },
    async fetchDados28d() {
      if (!this.estabelecimentoSelecionado) return;
      const hoje = this.$dayjs();
      try {
        const res = await this.$axios.get('/pedido', {
          params: {
            estabelecimento_id: this.estabelecimentoSelecionado.id,
            data_inicio: hoje.subtract(28, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
            data_fim: hoje.subtract(1, 'day').endOf('day').format('YYYY-MM-DD HH:mm:ss'),
            statusList: '1,2,3',
            orderDesc: 'data',
          },
        });
        this.pedidos28d = res.data;
      } catch (e) {
        this.pedidos28d = [];
      }
    },
    async fetchCuponsDestaque() {
      if (!this.estabelecimentoSelecionado) return;
      try {
        const res = await this.$axios.get('/cupom-desconto', {
          params: {
            estabelecimento_id: this.estabelecimentoSelecionado.id,
            destaque: 1,
          },
        });
        this.cuponsDestaque = res.data;
      } catch (e) {
        this.cuponsDestaque = [];
      }
    },
    trackBannerShown(cardType) {
      this.$firebase.logEvent(`resumo_cta_${cardType}_shown`);
    },
    handleCtaCupom(atalho, cardType) {
      this.$firebase.logEvent(`resumo_cta_${cardType}_clicked`);
      const query = cardType === 'novos_clientes' ? { scroll: 'primeiro' } : { scroll: atalho.tipo };
      this.$router.push({ path: '/delivery/cupom-desconto', query });
    },
    rankClass(i) {
      return ['top-item__rank--gold', 'top-item__rank--silver', 'top-item__rank--bronze'][i] || 'top-item__rank--default';
    },
  },
};
</script>

<style lang="scss" scoped>
.resumo-container {
  font-family: 'Poppins', 'Roboto', 'Helvetica', sans-serif;
}

.resumo-title {
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.2;
}

.resumo-subtitle {
  font-size: 14px;
  color: #888;
  margin-top: 2px;
}

// Periodo selector
.periodo-selector {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
}

.periodo-btn {
  padding: 8px 18px;
  border-radius: 20px;
  border: 1.5px solid #e0e0e0;
  background: #fff;
  color: #555;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  font-family: 'Poppins', 'Roboto', sans-serif;
  transition: all 0.2s;

  &:hover {
    border-color: #1d9a5a;
    color: #1d9a5a;
  }

  &--active {
    background: #1d9a5a;
    border-color: #1d9a5a;
    color: #fff;
    font-weight: 600;
  }
}

// KPI Cards
.kpi-card {
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.07);
  height: 100%;
  position: relative;
  transition: box-shadow 0.2s;

  &--clickable {
    cursor: pointer;

    &:hover {
      box-shadow: 0 6px 24px rgba(29,154,90,0.15);
    }
  }
}

.kpi-card__icon-wrap {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;

  &--green { background: rgba(29,154,90,0.12); }
  &--blue  { background: rgba(48,96,202,0.12); }
  &--purple{ background: rgba(100,50,180,0.12); }
  &--red   { background: rgba(255,75,75,0.12); }
}

.kpi-card__icon {
  font-size: 22px !important;

  .kpi-card__icon-wrap--green & { color: #1d9a5a !important; }
  .kpi-card__icon-wrap--blue &  { color: #3060CA !important; }
  .kpi-card__icon-wrap--purple &{ color: #6432b4 !important; }
  .kpi-card__icon-wrap--red &   { color: #FF4B4B !important; }
}

.kpi-card__label {
  font-size: 13px;
  font-weight: 600;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.kpi-card__value {
  font-size: 26px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.2;
}

.kpi-card__value--skeleton {
  height: 32px;
  width: 80%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.2s infinite;
  border-radius: 8px;
  margin: 4px 0;
}

@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.kpi-card__sub {
  font-size: 12px;
  color: #aaa;
  margin-top: 2px;
  margin-bottom: 8px;
}

.kpi-card__badge-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}

.kpi-badge {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 12px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 10px;

  .v-icon { font-size: 13px !important; }

  &--up {
    background: rgba(29,154,90,0.1);
    color: #1d9a5a;
    .v-icon { color: #1d9a5a !important; }
  }

  &--down {
    background: rgba(255,75,75,0.1);
    color: #FF4B4B;
    .v-icon { color: #FF4B4B !important; }
  }
}

.kpi-card__hint {
  font-size: 12px;
  color: #1d9a5a;
  margin-top: 10px;
  font-weight: 500;
  cursor: pointer;
}

.kpi-card__cta-cupom {
  display: flex;
  align-items: center;
  margin-top: 10px;
  padding: 8px 12px;
  background: rgba(201, 151, 30, 0.08);
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;

  span {
    font-size: 12px;
    font-weight: 600;
    color: #C9971E;
  }

  &:hover {
    background: rgba(201, 151, 30, 0.15);
  }
}

// Section title
.kpi-section-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 2px;
}

.kpi-section-sub {
  font-size: 12px;
  color: #aaa;
  margin-bottom: 16px;
}

// Chart
.chart-legend {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  font-size: 13px;
  color: #666;
}

.legend-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;

  &--atual    { background: #1d9a5a; }
  &--anterior { background: #bbb; }
}

.legend-text {
  font-size: 12px;
  color: #888;
}

.chart-wrapper {
  margin-top: 4px;
}

// Top list
.top-item {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f5f5f5;

  &:last-child { border-bottom: none; }
}

.top-item__rank {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
  margin-right: 12px;

  &--gold    { background: #FFF3CD; color: #B8860B; }
  &--silver  { background: #F0F0F0; color: #666; }
  &--bronze  { background: #FDE8D8; color: #B85C00; }
  &--default { background: #F5F5F5; color: #999; }
}

.top-item__info {
  flex: 1;
  min-width: 0;
}

.top-item__name {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.top-item__sub {
  font-size: 11px;
  color: #aaa;
}

.top-item__value {
  font-size: 14px;
  font-weight: 700;
  color: #1d9a5a;
  flex-shrink: 0;
  margin-left: 8px;
}

// Empty state
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 0;
  color: #ccc;
  gap: 8px;
  font-size: 14px;
}

.empty-state__icon {
  font-size: 36px !important;
  color: #ddd !important;
}
</style>
